import React from 'react'
import { IBannerData } from '../../exports/interfaces'

const BenefitsMemberBanner = (props: {benefitsMememberBannerData: IBannerData[]}) => {
  return (
    <section className="page-header" style={{marginTop: '71px'}}>
      <div
        className="page-header-bg"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_strapiUrl}${props?.benefitsMememberBannerData[0]?.attributes?.Image?.data?.attributes?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className="container">
        <div className="page-header__inner">
          <h2>{props?.benefitsMememberBannerData[0]?.attributes?.Title}</h2>
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span>/</span>
            </li>
            <li className="active">Benefits of Member</li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default BenefitsMemberBanner